<template>
  <el-dialog
    title="认证客户"
    :visible.sync="visible"
    width="450px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-form
      size="small"
      :model="model"
      :rules="customerFormRules"
      ref="customerForm"
      label-width="100px"
    >
      <el-form-item label="客户名称">
        <div class="text-gray">{{ model.name }}</div>
      </el-form-item>
      <el-form-item label="SAP Code" prop="sap_code">
        <el-input
          v-model="model.sap_code"
          placeholder="请输入 SAP Code 进行认证"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <p class="font-12 text-danger" style="line-height: 1.4em">
          注：若此 SAP Code 已经绑定了其它客户，则此客户将会被合并且替换。
        </p>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitCustomerForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { updateCustomer } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.customerForm.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      customerFormRules: {
        sap_code: [
          { required: true, message: '请输入 SAP Code', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    submitCustomerForm() {
      this.$refs.customerForm.validate(async (valid) => {
        if (valid) {
          let res = await updateCustomer(this.model)
          if (res.code == 0) {
            this.$emit('updatedCustomer', res.data)
            this.visible = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.el-autocomplete {
  width: 100%;
}
</style>